export const makeSeoFooterWrapper = ({ theme }) => {
  return `min-height: 246px;
          background-color: ${theme.colors.grey4};
          padding: 35px 0px;

          @media (min-width: 1200px) {
            padding: 40px 0px 0px;
          }
  `
}

export const makeUl = () => {
  return `list-style: none;
          text-align: left;
          padding: 0px;
          margin: 0px 0px 0px 20px;

          @media (min-width: 1200px) {
            margin: 0px;
          }
  `
}

export const makeHeading = () => {
  return `display: inline-block;
          cursor: pointer;
  `
}

export const makeLabel = () => {
  return `padding: 0px;`
}

export const makeLinking = () => {
  return `font-size: 12px;
          color: rgba(0, 0, 24, 0.6);
          line-height: 32px;
          text-align: left;
          text-transform: uppercase;
          padding: 0px;

          &:hover {
            color: rgba(0, 0, 24, 0.6);
            text-decoration: none;
          }
  `
}

export const makeLi = () => {
  return ``
}

export const makeButtonAllCollapse = ({ allCollapseOpened }) => {
  return `margin: 0px auto;
          transform: ${allCollapseOpened ? 'rotate(0deg)' : 'rotate(180deg)'};
          transition: max-height .5s ease-in-out;

          &:focus,
          &:active {
            outline: 0px;
          }
  `
}
